import React from 'react';
import ReloadButton from '../../../../features/ReloadButton/ReloadButton';
import { InputFieldSearch } from '../../../../utils/InputField';
import { useTransaction } from '../TransactionsProvider';

function PageHeaderLeftCol({ onChangeHandler, p }) {
    return (
        <div
            // onSubmit={handleOnEnter}
            className="customers_page_header_left_col flex-1 flex flex-row items-center gap-x-2 md:gap-x-4"
        >
            <InputFieldSearch
                label="Search by id or invoice id or customer...."
                name="q"
                onChange={onChangeHandler}
                formData={p}
                className="w-72 rounded-xl"
            />
            {/* <SelectOption
                name="status"
                placeholder="Status"
                formData={p}
                onChange={onChangeHandler}
                options={['Paid', 'Pending']?.map((d) => addOption(d, d, d?.toLowerCase()))}
                className="w-38 rounded-xl"
            /> */}
        </div>
    );
}

function PageHeaderRightCol() {
    const { handleReload } = useTransaction();
    return (
        <div className="customer_page_header_right_col flex-1 flex flex-row gap-2 justify-end items-center ">
            <ReloadButton height="h-10" width="w-10" onClick={handleReload} />
        </div>
    );
}

function TransactionPageHeader({ onChangeHandler, p }) {
    return (
        <div className="customer_page_header w-full mb-3 md:mb-7 flex flex-row justify-between items-center">
            <PageHeaderLeftCol onChangeHandler={onChangeHandler} p={p} />
            <PageHeaderRightCol />
        </div>
    );
}

export default TransactionPageHeader;
